import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

Vue.config.productionTip = false;

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
Vue.component('font-awesome-icon', FontAwesomeIcon);

import YouTube from 'vue-youtube';
Vue.use(YouTube);

Vue.config.devtools = process.env.NODE_ENV !== 'prod';

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
